import * as React from 'react';
import { SVGProps } from 'react';

export const Armrest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4454_84541)">
      <path
        d="M7.14723 28.9801C6.90624 28.9801 6.89178 28.9705 6.85322 28.956C6.75201 28.9078 6.69899 28.8018 6.71827 28.6958L7.39304 24.9074C7.41714 24.7773 7.53763 24.6905 7.67259 24.7146C7.80272 24.7387 7.88948 24.864 7.86538 24.9942L7.23881 28.503C7.42196 28.503 7.66777 28.503 7.9184 28.4933L9.31131 24.864C9.35951 24.7387 9.49928 24.6761 9.6246 24.7243C9.74991 24.7725 9.81257 24.9122 9.76437 25.0375L8.31362 28.8163C8.27988 28.9078 8.19312 28.9705 8.09191 28.9705C7.60511 28.9753 7.32074 28.9801 7.14723 28.9801Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M6.47781 10.7231C6.34285 10.7231 6.23682 10.6171 6.23682 10.4821V7.19983C6.23682 5.32975 7.75505 3.81152 9.62512 3.81152H24.3447C24.4797 3.81152 24.5857 3.91756 24.5857 4.05251C24.5857 4.18747 24.4797 4.2935 24.3447 4.2935H9.62512C8.02496 4.2935 6.72361 5.59484 6.72361 7.19501V10.4773C6.72361 10.6122 6.61758 10.7183 6.48263 10.7183L6.47781 10.7231Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M24.3443 23.7944L4.4145 23.7847C4.18797 23.7847 4 23.5967 4 23.3702V14.1162C4 12.839 5.03625 11.8027 6.3135 11.8027H6.65088C7.92812 11.8027 8.96438 12.839 8.96438 14.1162V19.4373H26.759C26.894 19.4373 27 19.5433 27 19.6783C27 19.8132 26.894 19.9192 26.759 19.9192H8.71857C8.58361 19.9192 8.47758 19.8132 8.47758 19.6783V14.1162C8.47758 13.1089 7.65821 12.2847 6.64606 12.2847H6.30868C5.30134 12.2847 4.47716 13.1041 4.47716 14.1162V23.3027L24.3395 23.3124C24.4744 23.3124 24.5805 23.4184 24.5805 23.5534C24.5805 23.6883 24.4744 23.7944 24.3395 23.7944H24.3443Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <g opacity="0.2">
        <mask
          id="mask0_4454_84541"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="11"
          width="7"
          height="13"
        >
          <path
            d="M8.74289 12.0388H4.24121V23.5388H8.74289V12.0388Z"
            fill="white"
            stroke="white"
            strokeWidth="0.8"
          />
        </mask>
        <g mask="url(#mask0_4454_84541)">
          <path
            d="M8.71873 19.6734V14.1113C8.71873 12.969 7.79333 12.0388 6.64622 12.0388H6.30883C5.16655 12.0388 4.23633 12.9642 4.23633 14.1113V23.3653C4.23633 23.4617 4.31344 23.5388 4.40984 23.5388H8.68017C8.68017 23.5388 8.7862 19.6011 8.71873 19.6734Z"
            fill="#071114"
            stroke="#071114"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <path
        d="M26.6678 17.0899H10.7625C10.6275 17.0899 10.5215 16.9839 10.5215 16.8489C10.5215 16.7139 10.6275 16.6079 10.7625 16.6079H26.6726C26.8075 16.6079 26.9136 16.7139 26.9136 16.8489C26.9136 16.9839 26.8075 17.0899 26.6726 17.0899H26.6678Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M22.3147 19.7844C22.1798 19.7844 22.0737 19.6784 22.0737 19.5435V6.51076C22.0737 6.37581 22.1798 6.26978 22.3147 6.26978C22.4497 6.26978 22.5557 6.37581 22.5557 6.51076V19.5435C22.5557 19.6784 22.4497 19.7844 22.3147 19.7844Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M8.71853 23.7654C8.58357 23.7654 8.47754 23.6593 8.47754 23.5244V19.6734C8.47754 19.5384 8.58357 19.4324 8.71853 19.4324C8.85348 19.4324 8.95952 19.5384 8.95952 19.6734V23.5244C8.95952 23.6593 8.85348 23.7654 8.71853 23.7654Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_4454_84541">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Armrest;
